import { useSingleEventList } from "../../actions/homeActions";
import { useNavigate, useParams } from "react-router-dom";
import { useFavouritelikeMutation } from "../../actions/homeActions";
import { useAuth } from "../../context/authContext";
import { useState } from "react";
import localimgpath from "../../js/localimgpath";
export default () => {
  const { id } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const userId = localStorage.getItem("userId");
  const [loadingapi, setLoadingapi] = useState(false);
  const {
    data: singleEvent,
    isLoading,
    isError,
    error,
    refetch,
  } = useSingleEventList(id);
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const mutation = useFavouritelikeMutation(setLoadingapi);
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading events: {error.message}</p>
      </div>
    );
  }
  const handleSevedEvent = (userId, event_id) => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      setLoadingapi(true);
      mutation.mutate(
        {
          instance_id: event_id, // ID of the specific talent/news/event/job
          instance_type: "event", // Can be one of: "talent", "news", "event", "job"
          user_id: userId, // ID of the user performing the action
          record_type: "Favourite",
        },
        {
          onSettled: () => {
            refetch();
          },
        }
      );
    }
  };
  const galleryImages = singleEvent?.galleries?.map((item) => ({
    original: `${localimgpath?.eventsGallery}/${item?.image}`,
    thumbnail: `${localimgpath?.eventsGallery}/${item?.image}`,
    originalAlt: item?.title || "Gallery Image",
    description: item?.title || "",
  }));
  const openGallery = (index) => {
    setSelectedIndex(index);
    setIsOpen(true);
  };

  const closeGallery = () => setIsOpen(false);
  return {
    isOpen,
    selectedIndex,
    userId,
    loadingapi,
    isLoggedIn,
    navigate,
    mutation,
    handleSevedEvent,
    galleryImages,
    openGallery,
    closeGallery,
    singleEvent,
    isLoading,
    error,
    localimgpath,
  };
};
